export const CLASS_NAME = 'cst-icon-arrow-down-right'
